import useRequestTable from 'app/hooks/useRequestTable'

import {
    RequestKeys,
} from 'app/hooks/useRequest'
import {
    CommentType,
} from 'app/shared-components/CommentsLog/CommentsLog.types'

import requestConfig from 'app/requests/Prebooking.requests'

const useGetPreBookingComments = (id: number) => {
    return useRequestTable<CommentType>({
        key: RequestKeys.getPreBookingComments,
        params: {
            id,
        },
        config: requestConfig.filterComments,
        keepPreviousData: true,
    })
}

export default useGetPreBookingComments
